@if (appState(); as appState) {
  @if (appState.isAuthInProgress) {
    <div class="d-flex justify-content-center align-items-center h-100 min-vh-100">
      <div class="spinner-border spinner-border-sm" role="status" id="authLoginProgressSpinner">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  @if (appState.hideNavigation) {
    <div class="app-bare">
      @if (appState.showContent) {
        <router-outlet></router-outlet>
      }
    </div>
  } @else {
    <!--Authenticated shell: header + side-nav + content + footer-->
    <div class="app-shell app-shell--chrome d-flex flex-column min-vh-100">
      <div id="app-header" class="app-shell__header sticky-top">
        <app-header (toggleNav)="toggleMobileNav()"></app-header>
      </div>

      @if (mobileNavOpen()) {
        <div class="app-shell__nav-overlay position-fixed top-0 start-0 w-100 h-100 d-md-none" (click)="closeMobileNav()"></div>
      }

      <div class="app-shell__body d-flex flex-column flex-md-row flex-grow-1 flex-shrink-0">
        <app-side-nav class="app-shell__nav flex-grow-0 flex-shrink-0" [mobileOpen]="mobileNavOpen()" (navigate)="closeMobileNav()"></app-side-nav>
        <main id="app-content" class="app-shell__content flex-fill p-3 p-md-4 overflow-x-auto">
          <div class="mh-section-content">
            @if (appState.showContent) {
              <router-outlet></router-outlet>
            }
          </div>
        </main>
      </div>

      <div class="app-shell__footer w-100">
        @defer (on viewport) {
          <app-footer></app-footer>
        } @placeholder {
          <div class="text-center p-3">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading footer...</span>
            </div>
          </div>
        }
      </div>
      <app-toast></app-toast>
    </div>
  }
}
